import { Fuel } from "lucide-react";

// Static lookup of fuel policy keys → user-facing copy. Backend is the source of truth for
// the canonical list but keeping a small mirror here lets us render before /meta/fuel-policies
// resolves on first paint.
const POLICY_COPY = {
  full_to_full: { label: "Full to Full", description: "Pick up the car with a full tank. Return it full — or pay the vendor's refuelling fee." },
  same_to_same: { label: "Same to Same", description: "Return the car with the same fuel level you picked it up with." },
  prepaid_full: { label: "Pre-paid full tank", description: "You'll pay for a full tank upfront and can return the car at any fuel level. No refunds for unused fuel." },
  free_tank:    { label: "Free tank included", description: "The vendor includes the first tank free. Return at any fuel level." },
};

export default function CarFuelPolicy({ policy }) {
  if (!policy) return null;
  const copy = POLICY_COPY[policy];
  if (!copy) return null;
  return (
    <div className="py-8 border-b border-border" data-testid="car-fuel-policy">
      <h3 className="font-display text-xl font-medium mb-3 flex items-center gap-2">
        <span className="h-8 w-8 rounded-lg bg-amber-50 ring-1 ring-amber-100 flex items-center justify-center">
          <Fuel className="h-4 w-4 text-amber-600" />
        </span>
        Fuel policy
      </h3>
      <div className="inline-flex items-center gap-2 text-sm font-medium px-3 py-1 rounded-full bg-emerald-50 text-emerald-800 border border-emerald-100 mb-3">
        {copy.label}
      </div>
      <p className="text-neutral-700 leading-relaxed text-sm">{copy.description}</p>
    </div>
  );
}
